import TodoListApp from "./TodoListApp";

import "./App.css";

function App() {
  return (
    <>
      <div id="bg-img"></div>
      <TodoListApp />
    </>
  );
}

export default App;
